import { apiClient } from '../../axios';
import {
  GetEconomicEventsParams,
  GetEconomicEventsResponse,
  GetFavoritesParams,
  GetFavoritesResponse,
  GetMarketBoostResponse,
  GetNewsParams,
  GetNewsResponse,
} from './types';

export const getFavoritesApi = (params?: GetFavoritesParams) =>
  apiClient.get<GetFavoritesResponse>('/v1/market/favorites', { params });

export const putFavoriteApi = (symbol: string, data: { favorite: boolean }) =>
  apiClient.put(`/v1/market/favorite/${symbol}`, data);

export const getEconomicEventsApi = (params?: GetEconomicEventsParams) =>
  apiClient.get<GetEconomicEventsResponse>('/v1/market/economic-events', { params });

export const getNewsApi = (params?: GetNewsParams) => apiClient.get<GetNewsResponse>('/v1/market/news', { params });

export const getMarketBoostApi = () => apiClient.get<GetMarketBoostResponse>('/v1/market/boost');
